import { IconButton, InputAdornment } from "@mui/material";
import { InputForm } from "components/ui/inputForm";
import { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { InputPasswordProps } from "../interfaces/firmaInterfaces";

export const InputPassword = ({
  className = "",
  ...props
}: InputPasswordProps) => {
  const {
    successFirmado,
    showPassword,
    handleClickShowPassword,
    handleMouseDownPassword,
  } = useContext(FirmaElectronicaContext);
  const { setValue } = useFormContext();

  useEffect(() => {
    if (successFirmado) {
      setValue("password", "", { shouldDirty: true });
    }
    // eslint-disable-next-line
  }, [successFirmado]);

  return (
    <InputForm
      type={showPassword ? "text" : "password"}
      name="password"
      label="Contraseña"
      autoComplete="off"
      className="w-full"
      rules={{
        required: {
          value: true,
          message: "El campo contraseña es requerida",
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <RiLockPasswordFill />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => handleClickShowPassword()}
              onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) =>
                handleMouseDownPassword(event)
              }
            >
              {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};
